import { MessagePaymentApproved } from "../../components/MessagePaymentApproved";
import HeaderWebsite from "../../components/HeaderWebsite";
import HeaderAccountFree from "../../components/HeaderAccountFree";
export default function PagePaymentApproved(props){
    const {
        userPlan,
        isLoggedIn,


        statusMode,
        setStatusMode,
        showLogoutButton,
        notificationVolume,
        setNotificationVolume,
        userData,
    } = props;
    return(

        <>
        {
            userPlan === "free" || userPlan === "Gratuito" ?
            <HeaderAccountFree statusMode={statusMode} />
            :
            <HeaderWebsite
            statusMode={statusMode}
            setStatusMode={setStatusMode}
            isLoggedIn={isLoggedIn}
            showLogoutButton={showLogoutButton}
            notificationVolume={notificationVolume}
            setNotificationVolume={setNotificationVolume}
            userData={userData}
            user={userData}
          />
        }

        <MessagePaymentApproved/>
        </>
    );
}